module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/arrow-right-black.92189bc6.svg";